import { render, staticRenderFns } from "./draftProductTiktok.vue?vue&type=template&id=8be23df0&scoped=true"
import script from "./draftProductTiktok.vue?vue&type=script&lang=js"
export * from "./draftProductTiktok.vue?vue&type=script&lang=js"
import style0 from "./draftProductTiktok.vue?vue&type=style&index=0&id=8be23df0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be23df0",
  null
  
)

export default component.exports